<template lang="html">
<div id="estado_cuenta_global">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
    <v-container fluid fill-height>
      <v-row>
        <v-col xs="12">
          <base-material-card color="primary" icon="library_books" title="Estado de Cuenta Global" subtitle="hola" class="elevation-1 px-5 py-3">
            <v-card-text>
              <v-card-subtitle>
                <span>Selección de fechas de aplicación para generar el Estado de Cuenta Global</span><br>
                <small class="red--text">*Estimado Usuario: la selección de fechas que a continuación se deben ingresar, NO se refieren a un rango de periodo. Los valores requeridos se refieren a la fecha de "Cargo" y "Abono" señalada en el Estado de Cuenta Global del SCCCyG que busca valorar.</small>
              </v-card-subtitle>
              <v-form ref="form" lazy-validation class="form_generador">
                <v-container fluid>
                  <v-row align="center" dense>
                    <v-col sm="12" md="2">
                      <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                        <template v-slot:activator="{ on }" >
                          <v-text-field v-on="on" v-model="fecha_cargo" label="Fecha de Cargo" color="secondary" prepend-icon="event" @blur="fecha_cargo = parseDate(fecha_cargo)" :rules="[rules.required, validaFecha]" v-mask="'####-##-##'">
                          </v-text-field>
                        </template>

                        <v-date-picker v-model="fecha_cargo" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                          <v-spacer />

                          <v-btn color="secondary" x-small @click="menu1 = false" >
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col sm="12" md="2">
                      <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                        <template v-slot:activator="{ on }" >
                          <v-text-field v-on="on" v-model="fecha_abono" label="Fecha de Abono" color="secondary" prepend-icon="event" @blur="fecha_abono = parseDate(fecha_abono)" :rules="[rules.required, validaFecha]" v-mask="'####-##-##'">
                          </v-text-field>
                        </template>

                        <v-date-picker v-model="fecha_abono" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                          <v-spacer />

                          <v-btn color="secondary" x-small @click="menu2 = false" >
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="success" @click="get_data_view()" small>
                  <v-icon>done</v-icon>Generar
                </v-btn>
                <v-btn v-if="Object.keys(data_estado).length !== 0" color="primary" @click="exportar('xlsx')" small>
                  <v-icon>mdi-file</v-icon>Excel
                </v-btn>
              </v-card-actions>
              <hr>
              <div v-if="show">
                <EstadoCuenta id="exportar_datos" v-if="Object.keys(data_estado).length !== 0" :parametros="data_estado"/>
              </div>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
      <LoaderFraces ref="estadoLoader" :mensajes="lista_mensajes" ></LoaderFraces>
    </v-container>
  </div>
</div>
</template>

<script>
import XLSX from 'xlsx';
import axios from "axios";
import moment from "moment";
import EstadoCuenta from "@/components/EstadoCuenta.vue";
import LoaderFraces from "@/components/LoaderFraces";

export default {
  components: {
    LoaderFraces,
      "EstadoCuenta": EstadoCuenta,
  },
  created: async function() {
    this.model = this.clean_model();
  },

  data: () => ({
    lista_mensajes: [
            "AGRADECEMOS SU PACIENCIA..",
            "ESTAMOS PROCESANDO LOS CARGOS..",
            "VERIFICANDO IDENTIFICADORES..",
            "VALIDACIÓN DE FORMAS DE PAGO..",
            "PROCESANDO ABONOS A LA FECHA..",
            "VERIFICANDO FRACCIONES..",
            "VALIDANDO CUENTAS POR IDENTIFICADOR DE ACTIVO..",
            "ANALIZANDO SOBREDESCARGO..",
            "GESTIONANDO SALDOS POR FRACCIÓN..",
            "TOTALIZANDO VALOR COMERCIAL PENDIENTE DE RETORNO..",
            "TOTALIZANDO CRÉDITO FISCAL.."
        ],
    show: false,
    data_estado: {},
    menu1: false,
    menu2: false,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Reportes",
        disabled: true,
        to: ""
      },
      {
        text: "Estado de Cuenta Global",
        disabled: true,
        to: ""
      }
    ],
    model: {},
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      },
      esArreglo: v => Array.isArray(v) && v.length > 0 || "Se deben agregar elementos a la lista"
    },
    fecha_cargo: "",
    fecha_abono: "",

  }),
  methods: {
    clean_model: function() {
      return {
        "rfc": this.$local_storage.get('rfc'),
        "folio_sat": "",
        "tipo": "",
        "periodo": "",
        "destino": "",
        "ejercicio": "",
        "folios": [],
        "no_movimiento": "",
        "pedimentos": [],
        "archivo": "",
        "planta": ""
      };
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida.";
      else
        return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    get_data_view: function() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$refs.estadoLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      let data = {
        "tipo": 1,
        "rfc": this.$local_storage.get('rfc'),
        "fecha_cargo": this.fecha_cargo,
        "fecha_abono": this.fecha_abono
      }
      var url = this.$apiSA31 + "soluciona31/reportes/estado_cuenta_global/";
      var url_test = "http://localhost:8000/soluciona31/reportes/estado_cuenta_global/";

      axios.post(url, data).then(response => {
        this.show = true;
        this.data_estado = response.data;

      }).catch(error => {
        let mensaje;
        var titulo = "¡Operación no Permitida!";
        var tipo = "error";
        if (typeof error.response !== "undefined") {
          mensaje = error.response.data.mensaje;
        } else {
          mensaje = "Ocurrió un error reportalo con el administrador.";
        }
        this.$swal({
          type: tipo,
          title: titulo,
          text: mensaje,
          footer: ""
        });
      }).then(() => {
        this.$refs.estadoLoader.hide();
      });
    },
    exportar: function(type, fn, dl) {
      var elt = document.getElementById('exportar_datos');
       var wb = XLSX.utils.table_to_book(elt, { sheet: "sheet1" });
       return dl ?
         XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' }):
         XLSX.writeFile(wb, fn || ('EstadoCuentaGlobal.' + (type || 'xlsx')));
    }
  },
}
</script>

<style lang="css" scoped>
label {
    font-size: 8px !important;
}
</style>
